import { css } from '@emotion/css';
import { Color, Font, FontWeight, Spacing } from 'src/styles';

export const amountValue = ({ isNegative }: { isNegative: boolean }) => css`
  ${FontWeight.bold}
  ${Font.lg}
  color: ${isNegative ? Color.Red8 : Color.Green8};
`;

export const disclaimerContainer = css`
  ${Spacing.pt8}
  ${Spacing.pb16}
`;

export const alert = css`
  ${Spacing.mt24}
  ${Spacing.p4}
  ${Spacing.ml0}
`;
